<template>
	<div>
		<div class="chongzhi w1200">
			<div class="tit">选择充值数额</div>
			<div class="list">
				<div v-for="(item,index) in list.arr" :key="index" :class="list.active == index?'active':''"
					@click="list.active = index">
					<div>{{item}}缩币</div>
					<span>￥ {{item}}.00</span>
				</div>
			</div>
			<div>
				<el-input placeholder="请输入充值金额" v-model="price" clearable>
				</el-input>
			</div>
			<hr />
			
			<div class="chongzhifangshi">
				<div>
					<span>微信</span>
					<span>支付宝</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				price:'',
				list: {
					active: 0,
					arr: [5, 15, 30, 50, 100, 200, 500, 1000]
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	.chongzhi {
		.tit {
			font-weight: bold;
			font-size: 30px;
			margin: 20px 0;
		}

		.list {
			width: 1000px;
			display: flex;
			flex-wrap: wrap;

			>div {
				text-align: center;
				background-color: orange;
				width: 200px;
				padding: 10px 0px;
				color: #ffffff;
				margin-right: 30px;
				margin-bottom: 30px;
				border-radius: 10px;
				cursor: pointer;

				&.active {
					background-color: orangered;
				}

				>div {
					font-size: 20px;
				}
			}
		}

		.chongzhifangshi {
			font-size: 28px;
			margin: 50px 0;

			span {
				border-radius: 10px;
				overflow: hidden;
				margin-right: 50px;
				background-color: #409EFF;
				color: #ffffff;
				padding: 10px 50px;
			}
		}
	}
</style>
